import { __assign } from "tslib";
import classNames from 'classnames';
import React from 'react';
import styles from './textarea.module.css';
/**
 * @deprecated replaced by 'TextArea'
 */
export var Textarea = React.forwardRef(function (props, ref) {
    var _a, _b, _c;
    var _d;
    var _e = props.haserror, hasError = _e === void 0 ? false : _e, _f = props.readOnly, readOnly = _f === void 0 ? false : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.responsive, responsive = _h === void 0 ? false : _h;
    var cleansedProps = __assign(__assign({}, props), { className: void 0, label: void 0, haserror: void 0, id: (_d = props.id) !== null && _d !== void 0 ? _d : props.name });
    return (React.createElement("div", { className: classNames(styles.textareaWrapper, 'inputWrapperDeprecated', props.className, (_a = { hasError: hasError }, _a[styles.hasLabel] = !!props.label, _a[styles.readOnly] = readOnly, _a[styles.disabled] = disabled, _a.responsive = responsive, _a), "kplr_textareaWrapper") },
        React.createElement("textarea", __assign({}, cleansedProps, { ref: ref, className: classNames(styles.textareaInput, (_b = {}, _b[styles.headless] = !props.label, _b)), placeholder: props.label })),
        !!props.label && (React.createElement("label", { className: classNames(styles.textareaLabel, (_c = {}, _c[styles.disabled] = disabled, _c)), htmlFor: props.name }, props.label))));
});
Textarea.displayName = 'Textarea';
export default Textarea;
